// extracted by mini-css-extract-plugin
export default {"backdrop":"Backdrop_backdrop__2A2cg","backdrop--light":"Backdrop_backdrop--light__3ma4f","backdrop--dark":"Backdrop_backdrop--dark__4WOra"};